// Where to send the user after sign-in. Same-app paths are always allowed; absolute URLs
// only when their origin matches TRUSTED_ORIGINS (served by /api/public-config), so other
// internal tools can bounce users here and get them back: /login?redirectTo=https://tool.edclub.tech/x
import { publicConfig } from './public-config'

const matches = (url: URL, pattern: string) => {
	const wildcard = pattern.match(/^(https?):\/\/\*\.(.+)$/)
	if (wildcard) return url.protocol === `${wildcard[1]}:` && url.hostname.endsWith(`.${wildcard[2]}`)
	return url.origin === pattern
}

/** Resolves a `redirectTo` value to an in-app path or a trusted external URL (default `/`). */
export async function resolveRedirect(to: string | undefined): Promise<{ path: string } | { href: string }> {
	if (!to) return { path: '/' }
	if (to.startsWith('/') && !to.startsWith('//')) return { path: to }
	try {
		const url = new URL(to)
		if (url.origin === location.origin) return { path: url.pathname + url.search + url.hash }
		const { trustedOrigins } = await publicConfig()
		if (trustedOrigins.some((pattern) => matches(url, pattern))) return { href: url.href }
	} catch {}
	return { path: '/' }
}
